import { apiClient } from "../api/apiclient"

export const postSprintTeam = (team, token) =>
    apiClient.post("/create-sprint",team, {
        headers: { Authorization: `Bearer ${token}` },
    });

export const getAllSprints = (token) =>
    apiClient.get("/sprints", {
        headers: { Authorization: `Bearer ${token}` },
    });
   export const updateSprint = (data, token) =>
  apiClient.put(`/update-sprint`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  export const deleteSprint = (id, token, moveAction = "backlog", targetSprintId = null) => {
  const params = new URLSearchParams();
  params.append("moveAction", moveAction);
  if (targetSprintId) params.append("targetSprintId", String(targetSprintId));
  return apiClient.delete(`/sprints/${id}?${params.toString()}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
  export const startSprint = (sprintId, token) =>
  apiClient.post(`/sprints/${sprintId}/start`, {}, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const stopSprint = (id, token, moveAction = "backlog", targetSprintId = null) => {
  const params = new URLSearchParams();
  params.append("moveAction", moveAction);
  if (targetSprintId) params.append("targetSprintId", targetSprintId);
  console.log(">>> stopSprint URL:", `/sprints/${id}/stop?${params.toString()}`);

  return apiClient.post(`/sprints/${id}/stop?${params.toString()}`, {}, {
    headers: { Authorization: `Bearer ${token}` }
  });
};